let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

for (const item of items) {
  let closeTimer;

  item.addEventListener("mouseenter", () => {
    clearTimeout(closeTimer);
    // Close any other open menus
    items.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });
    // Open the current menu
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", () => {
    closeTimer = setTimeout(() => {
      item.removeAttribute("open");
    }, 150);
  });
}
